import { adminHttpClient } from '../../commons/adminHttpClient'
import { CompanyAddressValues } from '../common/models'

const companyAddressApi = (companyAddress: CompanyAddressValues): Promise<any> => {
  return adminHttpClient.put('/AdminSignup/Gchra/Company/Address', companyAddress)
}

export default companyAddressApi
